module.exports = __webpack_public_path__ + "static/media/menu.401d13da.svg";